'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _linksoftAlbatros = require('linksoft-albatros');

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GiftItemMini = function (_Component) {
    (0, _inherits3.default)(GiftItemMini, _Component);

    function GiftItemMini(props) {
        (0, _classCallCheck3.default)(this, GiftItemMini);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GiftItemMini.__proto__ || (0, _getPrototypeOf2.default)(GiftItemMini)).call(this, props));

        _this.onImageError = function () {
            _this.setState({ imageUrl: '/Content/images/img-placeholder-big.jpg' });
        };

        _this.state = {
            imageUrl: (0, _config2.default)().url.productImage({ id: props.data.productId })
        };
        return _this;
    }

    (0, _createClass3.default)(GiftItemMini, [{
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props.data),
                _pickBy$productId = _pickBy.productId,
                productId = _pickBy$productId === undefined ? '' : _pickBy$productId,
                _pickBy$productName = _pickBy.productName,
                productName = _pickBy$productName === undefined ? '' : _pickBy$productName,
                _pickBy$amount = _pickBy.amount,
                amount = _pickBy$amount === undefined ? 0 : _pickBy$amount,
                _pickBy$pointsPrice = _pickBy.pointsPrice,
                pointsPrice = _pickBy$pointsPrice === undefined ? 0 : _pickBy$pointsPrice;

            var url = (0, _config2.default)().url.product({ id: productId, name: productName });

            return _react2.default.createElement(
                'div',
                { className: 'mini-c__item' },
                _react2.default.createElement(
                    'figure',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: url },
                        _react2.default.createElement('img', { src: this.state.imageUrl, onError: this.onImageError })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mini-c__i-info' },
                    _react2.default.createElement(
                        'a',
                        { className: 'mini-c__i-title', href: url },
                        productName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-flex justify-content-between align-items-center' },
                        _react2.default.createElement(
                            'div',
                            null,
                            amount,
                            ' x ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                pointsPrice || 0,
                                '\xA0b.'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'price__actual' },
                                pointsPrice * amount || 0,
                                '\xA0b.'
                            )
                        )
                    )
                )
            );
        }
    }]);
    return GiftItemMini;
}(_react.Component);

GiftItemMini.propTypes = {
    data: _propTypes2.default.object.isRequired,
    canChangeCart: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
    submitChanges: _actions2.default.submitChanges
})(GiftItemMini);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/GiftItemMini.js
// module id = 1123
// module chunks = 0